import "../../../assets/css/skeletons.css";

const UserProfileSkeleton = () => {
  return (
    <div className="wrapper-content skeleton-user-profile">
      <div className="main d-flex flex-column vh-100">
        <div className="skeleton-breadcrumb d-flex align-items-center flex-sh-0"></div>
        <div className="flex-grow-1 overflow-auto pt-20">
          <div className="container">
            <div className="row">
              <div className="block-config-data">
                <div className="skeleton-title"></div>
                <div className="skeleton-subtitle"></div>
                <div className="options d-flex">
                  <form>
                    <div className="mb-3">
                      <div className="skeleton-input-label"></div>
                      <div className="skeleton-input"></div>
                    </div>
                    <div className="mb-3">
                      <div className="skeleton-input-label"></div>
                      <div className="skeleton-input"></div>
                    </div>
                    <div
                      className="skeleton-button"
                      style={{ marginTop: "20px" }}
                    ></div>
                  </form>
                </div>
              </div>
              <div className="block-config-data mt-50 mb-50">
                <div className="skeleton-title"></div>
                <div className="skeleton-subtitle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileSkeleton;
